import { render } from "./MyPageSelectBox.vue?vue&type=template&id=c1131eb2&ts=true"
import script from "./MyPageSelectBox.vue?vue&type=script&lang=ts"
export * from "./MyPageSelectBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
